const play = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M6.54%202.159l14%209a1%201%200%200%201%200%201.682l-14%209A1%201%200%200%201%205%2021V3a1%201%200%200%201%201.54-.841zM7%204.832v14.336L18.15%2012%207%204.832z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  play as default
};
//# sourceMappingURL=play.svg.es.js.map
